import React, { useState } from "react";
import { PolicyFullObject } from "../../types/insurance.ts";

interface SearchPolicyProps {
  policyData: PolicyFullObject;
  onSearch: (policyNumber: string) => void;
  resetForm: () => void;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  children?: React.ReactNode;
}

const POLICY_NUMBER_REGEX = /^[0-9A-Z\/]{0,22}$/;

const SearchPolicy: React.FC<SearchPolicyProps> = ({
  policyData,
  onSearch,
  handleChange,
  resetForm,
  children,
}) => {
  const [validationError, setValidationError] = useState<string>("");

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value.toUpperCase();
    if (!POLICY_NUMBER_REGEX.test(value)) {
      setValidationError("Само A–Z, 0–9 и /. Макс. 22 символа.");
      return;
    }
    setValidationError("");
    handleChange({
      target: { name: "policyNumber", value },
    } as React.ChangeEvent<HTMLSelectElement>);
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (validationError) return;
    onSearch(policyData.policyNumber);
  };

  return (
    <div className="mb-2">
      <form onSubmit={handleSearch} className="flex items-center gap-2 pb-5">
        <div className="relative w-1/2">
          <input
            type="text"
            name="policyNumber"
            placeholder="Номер на полица"
            autoFocus={true}
            value={policyData?.policyNumber}
            onChange={handleInputChange}
            className={`border-stroke focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input dark:focus:border-primary w-full rounded border-[1.5px] px-3 py-2 text-sm font-semibold text-black outline-none transition dark:text-white ${
              validationError ? "!border-red-500" : ""
            }`}
          />
          {validationError && (
            <p className="absolute left-0 top-full mt-0.5 text-xs text-red-500">
              {validationError}
            </p>
          )}
        </div>
        <button
          type="submit"
          title="Търсене"
          disabled={!!validationError}
          className="bg-primary flex h-9 w-9 flex-shrink-0 items-center justify-center rounded text-white hover:bg-opacity-90 disabled:opacity-50"
        >
          <i className="fas fa-search text-sm" />
        </button>
        <div className="group relative">
          <button
            type="button"
            onClick={resetForm}
            title="Изчистване на всички данни"
            className="border-stroke hover:bg-accent hover:border-accent flex h-9 w-9 flex-shrink-0 items-center justify-center rounded border bg-white text-gray-500 hover:text-white"
          >
            <i className="fa-solid fa-trash text-sm" />
          </button>
          <span className="pointer-events-none absolute bottom-full left-1/2 mb-2 -translate-x-1/2 whitespace-nowrap rounded bg-black px-2 py-1 text-xs text-white opacity-0 transition-opacity group-hover:opacity-100">
            Изчистване на всички данни
          </span>
        </div>
        <div className="ml-auto">{children}</div>
      </form>
    </div>
  );
};

export default SearchPolicy;
